import { CheckCircle, ChevronDown, Circle, LogOut } from "lucide-react";
import logo from "../assets/logo.svg";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Separator } from "./ui/separator";
import { useEffect, useState } from "react";
import { user } from "../lib/api";
import { authClient } from "../auth-client";
import { useNavigate } from "@tanstack/react-router";

const logOut = async () => {
  localStorage.removeItem("forceBenelux");
  localStorage.removeItem("forceFrance");
  localStorage.removeItem("forceRussia");
  localStorage.removeItem("forcePoland");
  await authClient.signOut();
};

const toggleForceBenelux = () => {
  if (localStorage.getItem("forceBenelux") === "true") {
    localStorage.removeItem("forceBenelux");
  } else {
    localStorage.setItem("forceBenelux", "true");
    localStorage.removeItem("forceFrance");
    localStorage.removeItem("forceRussia");
    localStorage.removeItem("forcePoland");
  }
  window.location.href = "/";
};

const toggleForceFrance = () => {
  if (localStorage.getItem("forceFrance") === "true") {
    localStorage.removeItem("forceFrance");
  } else {
    localStorage.setItem("forceFrance", "true");
    localStorage.removeItem("forceBenelux");
    localStorage.removeItem("forceRussia");
    localStorage.removeItem("forcePoland");
  }
  window.location.href = "/";
};

const toggleForceRussia = () => {
  if (localStorage.getItem("forceRussia") === "true") {
    localStorage.removeItem("forceRussia");
  } else {
    localStorage.setItem("forceRussia", "true");
    localStorage.removeItem("forceBenelux");
    localStorage.removeItem("forceFrance");
    localStorage.removeItem("forcePoland");
  }
  window.location.href = "/";
};

const toggleForcePoland = () => {
  if (localStorage.getItem("forcePoland") === "true") {
    localStorage.removeItem("forcePoland");
  } else {
    localStorage.setItem("forcePoland", "true");
    localStorage.removeItem("forceBenelux");
    localStorage.removeItem("forceFrance");
    localStorage.removeItem("forceRussia");
  }
  window.location.href = "/";
};

export function Header() {
  const [currentUser, setCurrentUser] = useState<{
    name: string;
    email: string;
    allowedCountries: string[];
  }>({ name: "", email: "", allowedCountries: [] });
  const navigate = useNavigate();

  useEffect(() => {
    user().then(
      (user) => {
        setCurrentUser(user);
        if (user.allowedCountries.length === 0) {
          if (window.location.pathname !== "/article") {
            window.location.href = "/article";
          }
        }
      },
      (e) => {
        if (e instanceof Error) {
          if (e.message === "Unauthorized") {
            logOut();
          }
        }
      }
    );
  }, []);

  return (
    <>
      <div className="px-4 py-2 flex justify-between bg-white">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <div className="flex items-center hover:opacity-60 cursor-pointer">
              <img src={logo} alt="logo" />
              <ChevronDown className="inline" />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" forceMount>
            {currentUser?.allowedCountries?.length > 0 ? (
              <DropdownMenuItem asChild>
                <a href="/">Customer</a>
              </DropdownMenuItem>
            ) : null}
            <DropdownMenuItem asChild>
              <a href="/article">Article Availability</a>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Avatar className="h-8 w-8 text-zinc-950 cursor-pointer">
              <AvatarImage src="" />
              <AvatarFallback>{currentUser.email.slice(0, 2).toUpperCase()}</AvatarFallback>
            </Avatar>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" forceMount>
            <DropdownMenuLabel className="font-normal">
              <div className="flex flex-col space-y-1">
                <p className="text-sm font-medium leading-none">{currentUser.name}</p>
                <p className="text-xs leading-none text-zinc-500">{currentUser.email}</p>
              </div>
            </DropdownMenuLabel>
            {currentUser.allowedCountries.length > 1 ? (
              <>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={toggleForceBenelux}>
                  {localStorage.getItem("forceBenelux") === "true" ? (
                    <CheckCircle size="16" />
                  ) : (
                    <Circle size="16" />
                  )}
                  <span className="ml-2">Force Benelux</span>
                </DropdownMenuItem>
                <DropdownMenuItem onClick={toggleForceFrance}>
                  {localStorage.getItem("forceFrance") === "true" ? (
                    <CheckCircle size="16" />
                  ) : (
                    <Circle size="16" />
                  )}
                  <span className="ml-2">Force France</span>
                </DropdownMenuItem>
                <DropdownMenuItem onClick={toggleForceRussia}>
                  {localStorage.getItem("forceRussia") === "true" ? (
                    <CheckCircle size="16" />
                  ) : (
                    <Circle size="16" />
                  )}
                  <span className="ml-2">Force Russia</span>
                </DropdownMenuItem>
                <DropdownMenuItem onClick={toggleForcePoland}>
                  {localStorage.getItem("forcePoland") === "true" ? (
                    <CheckCircle size="16" />
                  ) : (
                    <Circle size="16" />
                  )}
                  <span className="ml-2">Force Poland</span>
                </DropdownMenuItem>
              </>
            ) : null}
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={() => {
                logOut();
                navigate({ to: "/" });
              }}
            >
              <LogOut size="16" />
              <span className="ml-2">Log out</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <Separator />
    </>
  );
}
